module.exports = __webpack_public_path__ + "static/logoCampana-64dbcd68b1e35c66e294bcfc7c7922bf.png";